// =====================================
//
//   超商付款 Controller
//   Author: Gray
//   createtime: 2017 / 10 / 30
//	 updatetime: 2017 / 10 / 30
//
// =====================================

window.InifECMobileApp.controller("PaymentSpgatewayCvsController", ['$scope', '$state', '$timeout', '$rootScope', '$stateParams', 'UserService', 'OrderService', 'ProductUtil',
	function($scope, $state, $timeout, $rootScope, $stateParams, UserService, OrderService, ProductUtil) {

        var getOrderInfo = function() {

            if($scope.isLoading) {
                return;
            }

            $scope.isLoading = true;
            OrderService.getOrderInfo($scope.orderid).then(function(result) {
                if(result) {

                    $scope.order = result;

                    // 如果不是審查合格狀態則踢掉
                    if($scope.order.orderstatus != 250 && $scope.order.orderstatus != 300){
                        $scope.isLoading = false;
                        $scope.isStatusError = true;
                    } else {
                        $scope.paidLimitTime = getPaidLimitTime($scope.order);
                        pay();
                    }
                    
                } else {
                    $scope.isLoading = false;
                    $scope.isError = true;
                }

            }, function(error) {

                if(error && (error.code == 'error.rscNotExist' || error.code == 'error.privilege.noReadable')) {
                    $scope.isOrderNotExist = true;
                }

                $scope.isError = true;                
                $scope.isLoading = false;
            });
        }

        var pay = function() {

            if(!$scope.order) {
                $scope.isError = true;
                return;
            }

            // 現階段 超商代收不可超過兩萬，最低不可低於27
            if($scope.order.totalamount > 20000 || $scope.order.totalamount < 27) {
                $scope.isError = true;                
                return;
            }

            var orderid = $scope.orderid,
                paymentmethod = Paytype_Spgateway_Cvs,
                totalamount = $scope.order.totalamount;

            OrderService.payForOrder(orderid, paymentmethod, totalamount).then(function(result) {
                if(result && result.logs && result.logs.length > 0) {
                    // 處理ATM資料
                    try {
                        var alllogs = result.logs;

                        for(var i = 0; i < alllogs.length; i++){
                            var logid = alllogs[i][0];
                            if(logid.paytype == Paytype_Spgateway_Cvs) {
                                var log = alllogs[i][1]

                                $scope.csvinfo = angular.fromJson(log.gatewayRstJSON);
                                break;
                            }
                        }

                    } catch (e) {
                        console.log(e);
                        $scope.isError = true;
                        $scope.isLoading = false;
                        return;
                    }

                    $scope.isLoading = false;
                    $scope.isError = false;
                    $scope.isComplete = true;
                } else {
                    $scope.isError = true;
                    $scope.isLoading = false;
                }             
            }, function(error) {
                $scope.isError = true;
                $scope.isLoading = false;
            });
        }

        var getPaidLimitTime = function(order) {

            var startPaidTime = 0;
            
            switch(order.productShoppingType) {
                case ProductUtil.ProductShoppingType.OLD_REVIEW_PAYMENT_PRINT:
                    startPaidTime = order.acceptedtime;
                    break;
                case ProductUtil.ProductShoppingType.DEFAULT_PAYMENT_REVIEW_PRINT:
                    startPaidTime = order.createtime;
                    break;
                case ProductUtil.ProductShoppingType.DESIGN_PAYMENT_REVIEW_PRINT:
                    startPaidTime = order.acceptedtime;
                    break;
                case ProductUtil.ProductShoppingType.STOCK_PAYMENT:
                    startPaidTime = order.createtime;
                    break;
                case ProductUtil.ProductShoppingType.ONLY_TEXT_REVIEW_PAYMENT_PRINT:
                    startPaidTime = order.acceptedtime;
                    break;
            }

            if(startPaidTime > 0) {
                return startPaidTime + 60 * 60 * 24 * 1000 * 7;    
            } else {
                return 0;
            }
        }

        var init = function() {
            
            UserService.getUserInfo().then(function(result) {
                $scope.isLogin = true;

                getOrderInfo();
            }, function(error) {
                $scope.isNoLogin = true;
                $scope.isLoading = false;
            });
        }

	    //==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================
        $scope.orderid = $stateParams.orderid;
        $scope.order;
        $scope.csvinfo;
        $scope.isError = false;
        $scope.isNoLogin = false;
        $scope.isLoading = false;
        $scope.isComplete = false;
        $scope.isOrderNotExist = false;
        $scope.isStatusError = false;
        $scope.paidLimitTime = 0;

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        init();
	}
]);